import React from 'react';
import ToyImage from './ToyImage';

export default function ThoughtBubble({ toyId, phase }) {
  const isPopping = phase === 'popping';
  const bubbleClass = isPopping
    ? 'anim-bubble-pop'
    : 'anim-float-bob anim-bubble-pulse';

  return (
    <div style={{
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      animation: 'float-in 0.6s cubic-bezier(0.34,1.56,0.64,1) both',
    }}>
      {/* Main bubble */}
      <div
        className={bubbleClass}
        style={{
          width: 140,
          height: 140,
          borderRadius: '50%',
          background: 'white',
          border: '5px solid #111',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '4px 4px 0 #111',
          padding: 12,
          position: 'relative',
        }}
      >
        <div style={{width: 100, height: 100}}>
          <ToyImage toyId={toyId}/>
        </div>
        {/* Shine */}
        <div style={{
          position:'absolute', top:14, left:18,
          width:28, height:18,
          borderRadius:'50%',
          background:'rgba(255,255,255,0.6)',
          transform:'rotate(-20deg)',
          pointerEvents:'none',
        }}/>
      </div>

      {/* Bubble tail dots */}
      <div style={{display:'flex', flexDirection:'column', alignItems:'center', gap:3, marginTop:2}}>
        <div style={dotStyle(16)}/>
        <div style={dotStyle(10)}/>
        <div style={dotStyle(6)}/>
      </div>
    </div>
  );
}

function dotStyle(size) {
  return {
    width: size,
    height: size,
    borderRadius: '50%',
    background: 'white',
    border: '3px solid #111',
  };
}
